module.exports = __webpack_public_path__ + "static/media/loginProfile1.f5307adf.svg";